import React, { useEffect, useRef, useState } from 'react'
//import CalendarContainer from './live-calendar-container' // Leaving this one as a backup
import CalendarContainer from 'live/components/time/ui/calendar/calendar-container'
import LiveModal from 'live/components/ui/Modal'
import i18n from 'live/services/i18n'
import '../../css/aggregator-base.css'

import { Action, Cancel, CalendarAdjusted, WarningText } from '../styles'

export const TimespanModal = ({
    showModal,
    cancelAction,
    submitAction,
    refElement,
    modalTitle,
    spanMessage
}: {
    showModal: boolean
    cancelAction: Function
    submitAction: Function
    refElement: React.MutableRefObject<HTMLInputElement>
    modalTitle: any
    spanMessage: any
}) => {

    const [dropdownOpen, toggleDropdown] = useState<boolean>(false)
    const baseRef = useRef(null)

    useEffect(() => {
        // Code inspired by https://stackoverflow.com/questions/32553158/detect-click-outside-react-component
        function clickOutside(event) {
          if (baseRef.current && !baseRef.current.contains(event.target) && refElement.current && !refElement.current.contains(event.target)) {
            toggleDropdown(false);
          }
        }
        // Bind the event listener
        document.addEventListener("mousedown", clickOutside);
        return () => {
          // Unbind the event listener on clean up
          document.removeEventListener("mousedown", clickOutside);
        };
    }, [baseRef]);

    const options = [{"labelEn":"Last hour","labelPt":"Última hora","value":"last hour"},
    {"labelEn":"Last 6 hours","labelPt":"Últimas 6 horas","value":"last 6 hours"},
    {"labelEn":"Last 12 hours","labelPt":"Últimas 12 horas","value":"last 12 hours"},
    {"labelEn":"Last 24 hours","labelPt":"Últimas 24 horas","value":"last 24 hours"},
    {"labelEn":"Last 7 days","labelPt":"Últimos 7 dias","value":"last 7 days"}]
    return (
            <LiveModal className="modal-xs-aggregator" show={showModal}>
                <LiveModal.Header>
                    <LiveModal.Title>{modalTitle}</LiveModal.Title>
                </LiveModal.Header>

                <LiveModal.Body>
                    <input type="text" ref={refElement} onClick={() => toggleDropdown(true)}
                    onKeyUp={ (e) => {if(e.key == 'Enter') {
                            e.preventDefault();
                            toggleDropdown(false);
                        }}}/>
                    <CalendarAdjusted ref={baseRef}>
                        <CalendarContainer
                            // restoreDefault={this.restoreDefault}
                            onChangeSpan={(span) => { refElement.current.value = span; toggleDropdown(false); }}
                            toggleDropdown={toggleDropdown}
                            initialSpan={"last 1 hour"}
                            open={dropdownOpen}
                            options={options}
                            currentSpan={refElement?.current?.value}
                        />
                    </CalendarAdjusted>
                    <small>
                        <em>{spanMessage}</em>
                        <em>{i18n('This request will, by default, use the timezone that the system understand as yours. If more precision is needed use either timestamps or set the specific timezone you want to use.')}</em>
                        {(refElement === null || refElement.current === null || refElement.current.value === null || refElement?.current?.value?.trim() === '') && (
                            <WarningText>
                                <small>
                                    <em>{i18n('Warning: Span is blank, no data will be reprocessed.')}</em>
                                </small>
                            </WarningText>
                        )}
                    </small>

                </LiveModal.Body>

                <LiveModal.Footer>
                    <Action style={{ marginRight: 5 }} onClick={() => {submitAction()}} className="btn btn-primary">
                        OK
                    </Action>
                    {i18n('or')} <Cancel onClick={() => {cancelAction()}}>{i18n('cancel')}</Cancel>
                </LiveModal.Footer>
            </LiveModal>
        )
}
